import { render, staticRenderFns } from "./r-level-page.vue?vue&type=template&id=4275a7f9"
import script from "./r-level-page.vue?vue&type=script&lang=js"
export * from "./r-level-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4275a7f9')) {
      api.createRecord('4275a7f9', component.options)
    } else {
      api.reload('4275a7f9', component.options)
    }
    module.hot.accept("./r-level-page.vue?vue&type=template&id=4275a7f9", function () {
      api.rerender('4275a7f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/level/r-level-page.vue"
export default component.exports